import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { userInfo } from '../services/accountsService';

const useAuth = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState({});
  const [userGroups, setUserGroups] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    userInfo().then(response => {
      if (response.success) {
        setIsLoggedIn(true);
        setUser(response.data);
        setUserGroups(response.data.groups || []);
      } else {
        navigate('/login');
      }
    }).catch(error => {
      console.error('Error checking login status', error);
      navigate('/login');
    });
  }, [navigate]);

  return { isLoggedIn, user, userGroups };
};

export default useAuth;
